import { useHistory } from 'react-router-dom';
import { Country } from '@tiendanube/common/src/enums';
import { HeaderContent, HeaderTop, IonPageStratus } from 'commons/components';
import useGetCountry from 'domains/Auth/hooks/useGetCountry';
import { useTrackBillingPayOrderCheckoutFinish } from 'domains/Billing/Checkout/hooks';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import {
  TransactionFeeToPayCard,
  TransactionFeePaidCard,
  PaymentsHistoryCard,
  TransactionFeesEmptyState,
  TransactionFeesPaymentStatusAlert,
  NuvemPagoFreeTransactionsAlert,
} from './components';
import { useIsTransactionFeeEmpty } from './hooks';

function TransactionFeesPage(): JSX.Element {
  const t = useTranslationBilling();
  const { goBack } = useHistory();
  const isEmpty = useIsTransactionFeeEmpty();
  const country = useGetCountry();
  const isMexico = country === Country.MX;

  useTrackBillingPayOrderCheckoutFinish();

  const backNavitation = {
    onClick: goBack,
  };
  return (
    <IonPageStratus
      headerTop={<HeaderTop navigation={backNavitation} />}
      headerContent={<HeaderContent title={t('transactionFeesPage.title')} />}
      width="small"
    >
      {isEmpty && <TransactionFeesEmptyState />}
      {!isEmpty && (
        <>
          <NuvemPagoFreeTransactionsAlert />
          <TransactionFeesPaymentStatusAlert />
          <TransactionFeeToPayCard />
          {!isMexico && <TransactionFeePaidCard />}
          <PaymentsHistoryCard />
        </>
      )}
    </IonPageStratus>
  );
}

export default TransactionFeesPage;
